import React, { Component } from "react";
import Login from "./containers/Login/Login";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Aux from "./hoc/Auxilliary";
import Main from "./containers/User/Main/Main";
import AdminContainer from "./containers/Admin/Admin";
import AdminLogin from "./containers/Admin/AdminLogin/AdminLogin";
import NoMatch from "./containers/User/Common/NoMatch/NoMatch";
import { clearStorage } from "./localstorage-service";
import { SESSION_TIMEOUT } from "./constants";
let time;
class App extends Component {
  componentDidMount() {
    window.onload = () => {
      this.inactivityTime();
    };
  }
  inactivityTime = () => {
    const resetTimer = this.resetTimer;
    window.onload = resetTimer;
    document.onload = resetTimer;
    document.onmousemove = resetTimer;
    document.onmousedown = resetTimer; // touchscreen presses
    document.ontouchstart = resetTimer;
    document.onclick = resetTimer; // touchpad clicks
    document.onkeypress = resetTimer;
    document.addEventListener("scroll", resetTimer, true); // improved; see comments
  };

  resetTimer = () => {
    // console.log("resetTimer");
    clearTimeout(time);
    time = setTimeout(this.timerDone, SESSION_TIMEOUT);
  };

  timerDone = () => {
    // alert("done");
    if (window.location.href.toLowerCase().indexOf("admin/login") === -1) {
      // const response = window.confirm("Session timeout! Press Ok to logout or Cancel to continue");
      // if (response) {
      clearStorage();
      window.location.href = "/admin/login";
      // } else {
      //   this.resetTimer();
      // }
    }
  };

  isAuthorized() {
    window.location.href = "/admin/login";
    const isAuthorized = sessionStorage.getItem("token") ? true : false;
    return isAuthorized;
  }

  isAdminAuthorized() {
    const isAuthorized = sessionStorage.getItem("admintoken") ? true : false;
    return isAuthorized;
  }

  render() {
    return (
      <BrowserRouter>
        <Aux>
          <Switch>
            <Route path="/admin/login" exact render={(props) => <AdminLogin key="login0" page="login" {...props} />} />
            {/* <Route
              path="/admin"
              exact
              render={props =>
                this.isAdminAuthorized() ? (
                  <AdminContainer key="login0" page="dashboard" {...props} />
                ) : (
                  <AdminLogin key="login0" page="login" {...props} />
                )
              }
            /> */}

            <Route
              path="/admin/modules"
              render={(props) =>
                this.isAdminAuthorized() ? (
                  <AdminContainer key="module" page="modules" {...props} />
                ) : (
                  <AdminLogin key="module" page="login" {...props} />
                )
              }
            />
            {/* <Route
              path="/admin/countries"
              exact
              render={props =>
                this.isAdminAuthorized() ? (
                  <AdminContainer key="login0" page="countries" {...props} />
                ) : (
                  <AdminLogin key="login0" page="login" {...props} />
                )
              }
            />
            <Route
              path="/admin/states/:id"
              render={props =>
                this.isAdminAuthorized() ? (
                  <AdminContainer key="login0" page="states" {...props} />
                ) : (
                  <AdminLogin key="login0" page="login" {...props} />
                )
              }
            />
            <Route
              path="/admin/jobroles/:id"
              render={props =>
                this.isAdminAuthorized() ? (
                  <AdminContainer key="login0" page="jobroles" {...props} />
                ) : (
                  <AdminLogin key="login0" page="login" {...props} />
                )
              }
            /> */}
            <Route
              path="/admin/users"
              exact
              render={(props) =>
                this.isAdminAuthorized() ? (
                  <AdminContainer key="login0" page="users" {...props} />
                ) : (
                  <AdminLogin key="login0" page="login" {...props} />
                )
              }
            />
            {/* <Route
              path="/admin/jobrolegroups"
              exact
              render={props =>
                this.isAdminAuthorized() ? (
                  <AdminContainer key="login0" page="jobrolegroups" {...props} />
                ) : (
                  <AdminLogin key="login0" page="login" {...props} />
                )
              }
            /> */}
            <Route
              path="/admin/:moduleid/categories"
              exact
              render={(props) =>
                this.isAdminAuthorized() ? (
                  <AdminContainer key="login0" page="categories" {...props} />
                ) : (
                  <AdminLogin key="login0" page="login" {...props} />
                )
              }
            />
            <Route
              path="/admin/:moduleid/:workflowid/workflowcategories"
              exact
              render={(props) =>
                this.isAdminAuthorized() ? (
                  <AdminContainer key="login0" page="workflowvideocategories" {...props} />
                ) : (
                  <AdminLogin key="login0" page="login" {...props} />
                )
              }
            />
            <Route
              path="/admin/:moduleid/:learningid/learningcategories"
              exact
              render={(props) =>
                this.isAdminAuthorized() ? (
                  <AdminContainer key="login0" page="learningcategories" {...props} />
                ) : (
                  <AdminLogin key="login0" page="login" {...props} />
                )
              }
            />
            <Route
              path="/admin/:moduleid/:learningid/learningvideocategories/:id"
              exact
              render={(props) =>
                this.isAdminAuthorized() ? (
                  <AdminContainer key="login0" page="learningvideocategories" {...props} />
                ) : (
                  <AdminLogin key="login0" page="login" {...props} />
                )
              }
            />
            <Route
              path="/admin/:moduleid/:learningid/learningvideocategories/:subcategoryid/videos/:videocategoryid"
              exact
              render={(props) =>
                this.isAdminAuthorized() ? (
                  <AdminContainer key="login0" page="learningvideos" {...props} />
                ) : (
                  <AdminLogin key="login0" page="login" {...props} />
                )
              }
            />
            <Route
              path="/admin/:moduleid/:workflowid/workflowcategories/videos/:videocategoryid"
              exact
              render={(props) =>
                this.isAdminAuthorized() ? (
                  <AdminContainer key="login0" page="workflowvideos" {...props} />
                ) : (
                  <AdminLogin key="login0" page="login" {...props} />
                )
              }
            />
            {/* <Route
              path="/admin/:moduleid/:learningid/assessment/:id"
              exact
              render={props =>
                this.isAdminAuthorized() ? (
                  <AdminContainer key="login0" page="assignment" {...props} />
                ) : (
                  <AdminLogin key="login0" page="login" {...props} />
                )
              }
            /> */}
            {/* <Route
              path="/admin/translation"
              exact
              render={props =>
                this.isAdminAuthorized() ? (
                  <AdminContainer key="login0" page="translation" {...props} />
                ) : (
                  <AdminLogin key="login0" page="login" {...props} />
                )
              }
            /> */}
            {/* <Route
              path="/admin/constants"
              exact
              render={props =>
                this.isAdminAuthorized() ? (
                  <AdminContainer key="login0" page="constants" {...props} />
                ) : (
                    <AdminLogin key="login0" page="login" {...props} />
                  )
              }
            /> */}
            <Route
              path="/admin/integration"
              exact
              render={(props) =>
                this.isAdminAuthorized() ? (
                  <AdminContainer key="login0" page="integration" {...props} />
                ) : (
                  <AdminLogin key="login0" page="login" {...props} />
                )
              }
            />
            <Route
              path="/"
              exact
              render={(props) =>
                this.isAuthorized() ? <Main page="home" {...props} /> : <Login key="login0" page="login" {...props} />
              }
            />
            {/* <Route path="/login" exact render={props => <Login key="login0" page="login" {...props} />} />
            <Route path="/login?id=:id" exact render={props => <Login key="login0" page="login" {...props} />} />
            <Route path="/register" exact render={props => <Login page="register" {...props} />} />
            <Route path="/forgotpassword" exact render={props => <Login page="forgotpassword" {...props} />} />
            <Route path="/resetpassword/:id" exact render={props => <Login page="resetpassword" {...props} />} /> */}
            {/* <Route
              path="/"
              exact
              render={props =>
                this.isAuthorized() ? <Main page="home" {...props} /> : <Login key="login0" page="login" {...props} />
              }
            /> */}
            {/* <Route
              path="/workflow"
              exact
              render={props =>
                this.isAuthorized() ? (
                  <Main page="workflow" {...props} />
                ) : (
                  <Login key="login0" page="login" {...props} />
                )
              }
            />
            <Route
              path="/learning"
              exact
              render={props =>
                this.isAuthorized() ? (
                  <Main page="learningcategories" {...props} />
                ) : (
                  <Login key="login0" page="login" {...props} />
                )
              }
            />
            <Route
              path="/learning/:id"
              exact
              render={props =>
                this.isAuthorized() ? (
                  <Main page="learningvideos" {...props} />
                ) : (
                  <Login key="login0" page="login" {...props} />
                )
              }
            /> */}
            <Route component={NoMatch} />
          </Switch>
        </Aux>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js